var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pair-item", class: { "cancel-able": _vm.cancelAble } },
    [
      _vm._v(_vm._s(_vm.item.name)),
      _vm.cancelAble
        ? _c("div", {
            staticClass: "cancel __pointer",
            on: { click: _vm.cancel }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }